(function () {
  if (window.__baiziguiCurrencyFixV62) return;
  window.__baiziguiCurrencyFixV62 = true;
  // V62 (2026-10-06): use function replacements — "S$" inside a replacement string turned "$$" into "$" and ate the first digit (S$52.63 -> S$22.63).

  var MAP = { MY:"MYR", SG:"SGD", AU:"AUD", HK:"HKD", TW:"TWD", US:"USD", CN:"CNY", GB:"GBP", AE:"AED", CA:"CAD" };
  var PREFIX = { SGD:"S$", AUD:"A$", HKD:"HK$", USD:"US$", TWD:"NT$", EUR:"€", GBP:"£", CNY:"¥", MYR:"RM", CAD:"C$", AED:"AED " };

  function placeNovaBar() {
    var block = document.querySelector(".bacurr-cur-block");
    if (!block) return false;
    block.classList.remove("desktopHidden", "hideOnMobile");
    block.style.setProperty("display", "block", "important");
    block.style.setProperty("top", "auto", "important");
    block.style.setProperty("bottom", "96px", "important");
    block.style.setProperty("left", "12px", "important");
    block.style.setProperty("right", "auto", "important");
    block.style.setProperty("z-index", "40", "important");
    return true;
  }

  function currentCountry() {
    try { if (window.Shopify && Shopify.country) return String(Shopify.country).toUpperCase(); } catch (e) {}
    var m = document.cookie.match(/(?:^|; )localization=([^;]*)/);
    if (m && m[1]) return decodeURIComponent(m[1]).toUpperCase().slice(0, 2);
    var inp = document.querySelector('input[name="country_code"], select[name="country_code"]');
    if (inp && inp.value) return String(inp.value).toUpperCase().slice(0, 2);
    return null;
  }

  function activeCurrency() {
    var sel = document.querySelector("#baCurrSelector, select.bacurr-cur-select, .bacurr-cur-block select");
    if (sel && sel.value) return String(sel.value).toUpperCase();
    try {
      var u = sessionStorage.getItem("bacurr_user_cur");
      if (u) return String(JSON.parse(u) || u).replace(/"/g, "").toUpperCase();
    } catch (e) {}
    var cc = currentCountry();
    return (cc && MAP[cc]) || "MYR";
  }

  function setNovaCurrency(code) {
    if (!code) return;
    code = String(code).toUpperCase();
    try {
      sessionStorage.setItem("bacurr_user_cur", JSON.stringify(code));
      sessionStorage.setItem("bacurrGeoCurrency", JSON.stringify(code));
      localStorage.setItem("baizigui_pref_currency", code);
    } catch (e) {}
    var sel = document.querySelector("#baCurrSelector, select.bacurr-cur-select, .bacurr-cur-block select");
    if (!sel) return;
    if (String(sel.value).toUpperCase() === code) return;
    if (window.__baiziguiForcedCur === code) return;
    window.__baiziguiForcedCur = code;
    sel.value = code;
    try { sel.dispatchEvent(new Event("change", { bubbles: true })); } catch (e) {}
  }

  function getRates() {
    try { if (window.Currency && Currency.rates) return Currency.rates; } catch (e) {}
    try {
      var raw = sessionStorage.getItem("bacurrConvStates");
      if (!raw) return null;
      var o = JSON.parse(raw);
      var src = o.currencyRateToday || "";
      var m = src.match(/rates:\s*(\{[\s\S]*?\})/);
      if (!m) return null;
      return (new Function("return " + m[1]))();
    } catch (e) { return null; }
  }

  function convertAmount(amount, from, to) {
    var rates = getRates();
    if (!rates || rates[from] == null || rates[to] == null) return null;
    return amount * rates[from] / rates[to];
  }

  function patchHeader() {
    var cur = activeCurrency();
    document.querySelectorAll(".currency-code, .localization-form__currency").forEach(function (el) {
      var t = (el.textContent || "").trim().toUpperCase();
      if (!t) return;
      if (t === "MYR" || t === "RM" || /^[A-Z]{3}$/.test(t)) {
        if (t !== cur) el.textContent = cur;
      }
    });
    document.querySelectorAll(".localization-form__currency").forEach(function (el) {
      el.style.setProperty("display", "none", "important");
    });
  }

  function prefixBareDollars() {
    var cur = activeCurrency();
    var pref = PREFIX[cur];
    if (!pref || cur === "MYR") return;
    // Direct fix on common price nodes first (Nova often rewrites these)
    document.querySelectorAll(".money, .price-item, .price, [class*=\"price\"]").forEach(function (el) {
      if (!el || el.childElementCount > 3) return;
      var t = el.textContent;
      if (!t || t.indexOf("$") === -1) return;
      var next = t.replace(/(^|[\s(])\$(\d)/g, function (m, a, d) { return a + pref + d; });
      if (cur !== "USD") next = next.replace(/US\$(\d)/g, function (m, d) { return pref + d; });
      // also leading bare dollar
      next = next.replace(/^\$(\d)/, function (m, d) { return pref + d; });
      if (next !== t && el.childElementCount === 0) el.textContent = next;
      else if (next !== t) {
        // rewrite text nodes inside
        var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
        var n, nodes = [];
        while ((n = w.nextNode())) nodes.push(n);
        nodes.forEach(function (tn) {
          var v = tn.nodeValue;
          if (!v || v.indexOf("$") === -1) return;
          var nv = v.replace(/(^|[\s(])\$(\d)/g, function (m, a, d) { return a + pref + d; });
          nv = nv.replace(/^\$(\d)/, function (m, d) { return pref + d; });
          if (cur !== "USD") nv = nv.replace(/US\$(\d)/g, function (m, d) { return pref + d; });
          if (nv !== v) tn.nodeValue = nv;
        });
      }
    });
    // Whole-body pass for leftovers (filters, banners)
    var re = /(^|[\s(])\$(\d[\d,]*(?:\.\d{1,2})?)/g;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = w.nextNode())) {
      if (!n.nodeValue || n.nodeValue.indexOf("$") === -1) continue;
      if (n.parentElement && n.parentElement.closest && n.parentElement.closest("script,style,noscript,textarea")) continue;
      nodes.push(n);
    }
    nodes.forEach(function (tn) {
      var v = tn.nodeValue;
      var next = v.replace(re, function (m, a, num) { return a + pref + num; });
      next = next.replace(/^\$(\d)/, function (m, d) { return pref + d; });
      if (cur !== "USD") next = next.replace(/US\$(\d)/g, function (m, d) { return pref + d; });
      // converted amount must not keep the base-currency label (e.g. "S$52.63 MYR")
      if (next.indexOf(pref) !== -1) next = next.replace(/(\d)\s*MYR\b/g, function (m, d) { return d + " " + cur; });
      if (next !== v) tn.nodeValue = next;
    });
  }

  function convertLeftoverRm() {
    var cur = activeCurrency();
    if (cur === "MYR") return;
    var pref = PREFIX[cur] || (cur + " ");
    var re = /\bRM\s*([\d,]+(?:\.\d{1,2})?)/gi;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = w.nextNode())) {
      if (!n.nodeValue || !/RM\s*[\d]/i.test(n.nodeValue)) continue;
      if (n.parentElement && n.parentElement.closest && n.parentElement.closest("script,style,noscript,textarea")) continue;
      // skip filter chrome like "RM to RM" without amounts handled below
      // keep Malaysia-only shipping thresholds in RM (banner/policy), e.g. "West Malaysia RM80 & above"
      if (/Malaysia|西马|东马|Semenanjung|Sabah|Sarawak/i.test(n.nodeValue)) continue;
      nodes.push(n);
    }
    nodes.forEach(function (tn) {
      var v = tn.nodeValue;
      // "RM to RM" facet label → active currency code
      if (/^\s*RM\s*$/i.test(v)) {
        tn.nodeValue = cur;
        return;
      }
      if (/RM\s+to\s+RM/i.test(v)) {
        tn.nodeValue = v.replace(/RM/gi, cur);
        return;
      }
      var next = v.replace(re, function (m, num) {
        var amt = parseFloat(String(num).replace(/,/g, ""));
        if (!isFinite(amt)) return m;
        var out = convertAmount(amt, "MYR", cur);
        if (out == null || !isFinite(out)) return m;
        if (out > amt * 2 || out < amt * 0.05) return m;
        return pref + out.toFixed(2);
      });
      if (next !== v) tn.nodeValue = next;
    });
  }

  function sync(forceBar) {
    try {
      if (forceBar) placeNovaBar();
      var cc = currentCountry();
      if (cc && MAP[cc]) setNovaCurrency(MAP[cc]);
      patchHeader();
      prefixBareDollars();
      convertLeftoverRm();
    } catch (e) {}
  }

  function boot() {
    placeNovaBar();
    sync(true);
    // Nova rewrites prices asynchronously — keep correcting briefly
    var n = 0;
    var iv = setInterval(function () {
      sync(false);
      if (++n >= 20) clearInterval(iv);
    }, 500);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  try {
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; sync(false); }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  } catch (e) {}

  document.addEventListener("change", function (ev) {
    var t = ev.target;
    if (!t) return;
    if (t.name === "country_code" || t.id === "baCurrSelector" || (t.className && String(t.className).indexOf("bacurr") !== -1)) {
      window.__baiziguiForcedCur = null;
      setTimeout(function () { sync(true); }, 250);
    }
  }, true);
})();
